import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { View } from '../../../../shared/store/view/types';
import { ChequeRemittanceModel } from '../../../../shared/store/cheque-remittance/types';
import { ActivatedRoute, Router } from '@angular/router';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ViewService } from '../../../../shared/store/view/views.service';
import { ChequeRemittanceService } from '../../../../shared/store/cheque-remittance/cheque-remittance.service';
import { filter, take } from 'rxjs/operators';
import { filterTrue } from '../../../../shared/pipe/rxjs/operators';
import { formatDate } from '../../../../shared/helper/datehelper';

@UntilDestroy()
@Component({
  selector: 'app-cheque-remittance-details',
  standalone: false,
  templateUrl: './cheque-remittance-details.component.html',
  styleUrl: './cheque-remittance-details.component.scss',
})
export class ChequeRemittanceDetailsComponent implements OnInit, OnDestroy {
  chequeRemittanceId: number;
  chequeRemittanceModel$: Observable<ChequeRemittanceModel>;
  view$: Observable<View>;
  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
    private readonly chequeRemittanceService: ChequeRemittanceService,
  ) {
    this.chequeRemittanceModel$ = this.chequeRemittanceService.getById.value$;
    this.view$ = this.viewService.getViews.value$;
  }
  ngOnInit(): void {
    this.chequeRemittanceId = this.route.snapshot.params['id'];

    this.chequeRemittanceService.getById.call(
      this.chequeRemittanceId.toString(),
    );

    this.chequeRemittanceModel$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set(
          '@chequeRemittanceDetails',
          x.salesTeamAccountName,
        );
      });

    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'downloadChequeRemittancePdf') this.downloadChequeRemittance();
        if (x == 'deleteChequeRemittance') this.deleteChequeRemittance();

        this.subHeaderService.setTriggerAction('');
      });
  }

  private downloadChequeRemittance() {
    const getFileSubscription =
      this.chequeRemittanceService.getChequeRemittancePdf.value$
        .pipe(
          // tap((x) => {
          //   console.log(x);
          // }),
          filter((x) => !!x),
          take(1),
        )
        .subscribe((result: Blob) => {
          const fileURL = window.URL.createObjectURL(result);
          let tab = window.open();
          if (tab) {
            tab.location.href = fileURL;
          }
          this.chequeRemittanceService.getChequeRemittancePdf.reset();
        });

    this.chequeRemittanceService.getChequeRemittancePdf.call(
      this.chequeRemittanceId,
    );
  }

  private deleteChequeRemittance() {
    let result$ = this.chequeRemittanceService.delete.call(
      this.chequeRemittanceId.toString(),
    );

    result$.pipe(filterTrue(), take(1)).subscribe((result) => {
      this.chequeRemittanceService.delete.reset();
      this.router.navigate(['Finance/ChequeRemittances/List']);
    });
  }

  ngOnDestroy(): void {
    this.chequeRemittanceService.getById.reset();
    this.chequeRemittanceService.delete.reset();
    this.breadcrumbService.set('@chequeRemittanceDetails', ' ');
  }
}
